/**
 * Reducers specify how the application's state changes in response to actions sent to the store.
 *
 * @see https://redux.js.org/basics/reducers
 */

import { createReducer } from 'reduxsauce';
import { ItemList02Types } from './Actions';
import INITIAL_STATE from './InitialState';

export const itemList02ResetTimestamp = (state, { currentPage, sorts, filters, pageSize }) => ({
  ...state,
  currentPage: currentPage || state.currentPage,
  sorts: sorts || state.sorts,
  filters: filters || state.filters,
  pageSize: pageSize || state.pageSize,
  timestamp: Date.now(),
  // selectedDocuments: INITIAL_STATE.selectedDocuments,
  toStorageBinOptions: INITIAL_STATE.toStorageBinOptions,
  toStorageBinOption: INITIAL_STATE.toStorageBinOption
});

export const itemList02FetchItemList02Loading = (state, { boolean }) => ({
  ...state,
  fetchIsLoading: boolean
});

export const itemList02FetchItemList02Success = (
  state,
  { documents, currentPage, lastPage, total, pageSize }
) => ({
  ...state,
  documents,
  currentPage,
  lastPage,
  total,
  pageSize
});

export const itemList02AddSelectedDocuments = (state, { selectedDocuments }) => {
  const selectIds = state.selectedDocuments.map(value => value.id);
  return {
    ...state,
    selectedDocuments: [
      ...state.selectedDocuments,
      ...selectedDocuments.filter(data => {
        return !selectIds.includes(data.id);
      })
    ]
  };
};

export const itemList02RemoveSelectedDocuments = (state, { selectedDocuments }) => {
  const selectIds = selectedDocuments.map(value => value.id);
  return {
    ...state,
    selectedDocuments: state.selectedDocuments.filter(data => {
      return !selectIds.includes(data.id);
    })
  };
};

export const itemList02SetWorkspaceVisible = (state, { boolean }) => ({
  ...state,
  workspaceIsVisible: boolean
});

/**
 * @see https://github.com/infinitered/reduxsauce#createreducer
 */
export const reducer = createReducer(INITIAL_STATE, {
  [ItemList02Types.ITEM_LIST02_RESET_TIMESTAMP]: itemList02ResetTimestamp,
  [ItemList02Types.ITEM_LIST02_FETCH_ITEM_LIST02_LOADING]: itemList02FetchItemList02Loading,
  [ItemList02Types.ITEM_LIST02_FETCH_ITEM_LIST02_SUCCESS]: itemList02FetchItemList02Success,
  [ItemList02Types.ITEM_LIST02_ADD_SELECTED_DOCUMENTS]: itemList02AddSelectedDocuments,
  [ItemList02Types.ITEM_LIST02_REMOVE_SELECTED_DOCUMENTS]: itemList02RemoveSelectedDocuments,
  [ItemList02Types.ITEM_LIST02_SET_WORKSPACE_VISIBLE]: itemList02SetWorkspaceVisible
});
